<template>
  <div>
    <div class="container">
    <h1>{{$t('AngeboteSelf.Headline')}}</h1>
    </div>
    <div class="list">
        <div class="container">
          <div class="row">
            <div class="col-12">
            <Angebot :Angebote="Angebote" :isOnMerkliste="true" :key="key"/>
            </div>
          </div>

        </div>
    </div>
  </div>
</template>
<script>
import Angebot from "@/components/angebot/vermieter/AngebotVermieter";
import AngebotService from "@/services/AngebotService";
import { mapGetters } from 'vuex'

import NProgress from "nprogress";
export default {
  name: "ListeVermieter",
  components: {
    Angebot,
  },
  data(){
      return{
        Angebote: [],
        Texte: "",
        key: 0
      }
  },
  methods:{
      showModal(id){
        this.$refs.modal.showIt(id)
      },
    refreshAngebote(){
        console.log("Last refesh")
      this.key++;

      AngebotService.getAngeboteSelf(this.$store.getters.userObject.account)
              .then(response => {
                this.Angebote = response.data;
                console.log("Load new Angebote: " + this.Angebote)
              })
              .catch(error => {
                console.log("There was an error:", error.response);
              });
    },
  },
  computed:{
    ...mapGetters([
      'userObject',
    ])
  },
  created() {
    let id = this.userObject.account;
    this.Texte = this.$locales.Texte;
    AngebotService.getAngeboteSelf(id)
            .then(response => {
              let angebotData = response.data;
              this.Angebote = angebotData; // <--- set the events when returned
            })
            .catch(error => {
              console.log("There was an error:", error.response);
            });
  },
};
</script>
